import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../components/global/Button';

const propTypes = {
  onAdd: PropTypes.func.isRequired,
  onImport: PropTypes.func.isRequired,
};

const AccountAddressBookNullState = ({ onAdd, onImport }) => {
  return (
    <div className="p-2 text-center">
      Your address book is empty.{' '}
      <Button btnStyle="link" onClick={onAdd}>
        Add
      </Button>{' '}
      a new contact or{' '}
      <Button onClick={onImport} btnStyle="link">
        import
      </Button>{' '}
      your contacts from a spreadsheet or CSV file.
    </div>
  );
};

AccountAddressBookNullState.propTypes = propTypes;

export default AccountAddressBookNullState;
